import clsx from "clsx";
import { UserGroupIcon } from "@heroicons/react/24/outline";
import type { DashboardStatsProps } from "@/features/Dashboard";
import { SENIORITY_ORDER } from "@/features/Dashboard";
import { DASHBOARD_STATS_CLASSES } from "./dashboardStats.definitions";

export default function DashboardStats({
  totalResources,
  seniorityTotals,
  loading = false,
}: DashboardStatsProps) {
  if (loading) {
    return (
      <div className={clsx(DASHBOARD_STATS_CLASSES.container, "animate-pulse")}>
        <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
        <div className="h-12 bg-gray-200 rounded w-1/4 mb-4"></div>
        <div className="grid grid-cols-3 gap-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-gray-50 rounded-lg p-3">
              <div className="h-4 bg-gray-200 rounded mb-2"></div>
              <div className="h-6 bg-gray-200 rounded"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={DASHBOARD_STATS_CLASSES.container}>
      <div className={DASHBOARD_STATS_CLASSES.header}>
        <div>
          <h3 className={DASHBOARD_STATS_CLASSES.title}>
            Total de Recursos Necessários
          </h3>
          <p className={DASHBOARD_STATS_CLASSES.subtitle}>
            Propostas com temperatura "Morno" ou superior
          </p>
        </div>
        <div className={DASHBOARD_STATS_CLASSES.iconContainer}>
          <UserGroupIcon className="h-6 w-6 text-primary-600" />
        </div>
      </div>

      <div className="mt-4">
        <div className="flex items-baseline">
          <div className={DASHBOARD_STATS_CLASSES.totalValue}>
            {totalResources}
          </div>
          <span className={DASHBOARD_STATS_CLASSES.totalLabel}>recursos</span>
        </div>

        <div className="mt-2 grid grid-cols-3 gap-4">
          {SENIORITY_ORDER.map((seniority) => (
            <div
              key={seniority}
              className={DASHBOARD_STATS_CLASSES.seniorityCard}
            >
              <div className={DASHBOARD_STATS_CLASSES.seniorityLabel}>
                {seniority}
              </div>
              <div className={DASHBOARD_STATS_CLASSES.seniorityValue}>
                {seniorityTotals[seniority] || 0}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
